import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import { store } from './store'
import { i18n } from './plugins/i18n';
// import { loadFonts } from './plugins/webfontloader'
import {appInit} from "@/services/initializer.service";
import axios from "axios";
import VueObserveVisibility from 'vue3-observe-visibility'
import { VueHeadMixin,createHead } from '@vueuse/head'

// import { registerSW } from 'virtual:pwa-register'

// const updateSW = registerSW({
//         onNeedRefresh() {
//                 console.log("reload")
//         },
//         onOfflineReady() {},
// })

// import Particles from "vue3-particles";
axios.defaults.headers = {
        'os' : "web",
        'release': 2
};
// loadFonts().then(r => (console.log(r + "load")))
const app = createApp(App)
  .use(router)
  .use(vuetify)
  .use(i18n)
  .use(store)
  .use(VueObserveVisibility)
appInit(app, router);
const head = createHead();
app.use(head);
app.mixin(VueHeadMixin)
app.mount('#app')

